export const STATUS_CODE = {
  SUCCESS_CODE: "030100000",      // 通用，成功状态码
  SUCCESS_INACCESSIBLE_CODE: "030100011",  // 活动未开始或已结束
  SUCCESS_COURIER_CODE: "030100012",   // 快递员状态码   
  SUCCESS_NO_APP_LOGIN: "030100023",   // APP 未登录
  SUCCESS_NOT_BIND: "030100005",   // 未绑定手机号
};